import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Box } from '@mui/material';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs'; // Import dayjs for date manipulation


const DateRangePicker = ({ index, filter, handleChange }) => {
  // Initialize startDate and endDate from filter?.value
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // Split filter?.value into startDate and endDate when filter?.value changes
  useEffect(() => {
    if (filter?.value) {
      const [start, end] = filter.value.split(';');
      setStartDate(start ? dayjs(start) : null);
      setEndDate(end ? dayjs(end) : null);
    }
  }, [filter?.value]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        {/* Start Date Picker */}
        <DatePicker
          label="Start Date"
          fullWidth
          value={startDate}
          onChange={(newDate) => {
            setStartDate(newDate); // Set the new start date state
            // Combine start and end dates and send as a single string
            handleChange(index, "value", `${newDate ? newDate.format('YYYY-MM-DD') : ''};${endDate ? endDate.format('YYYY-MM-DD') : ''}`);
          }}
          slotProps={{
            textField: {
              variant: 'outlined',
              size: "small",
              fullWidth: true,
            },
          }}
        />

        {/* End Date Picker */}
        <DatePicker
          label="End Date"
          fullWidth
          value={endDate}
          onChange={(newDate) => {
            setEndDate(newDate); // Set the new end date state
            // Combine start and end dates and send as a single string
            handleChange(index, "value", `${startDate ? startDate.format('YYYY-MM-DD') : ''};${newDate ? newDate.format('YYYY-MM-DD') : ''}`);
          }}
          slotProps={{
            textField: {
              variant: 'outlined',
              size: "small",
              fullWidth: true,
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default DateRangePicker;
